module.exports = __webpack_public_path__ + "static/media/ResetPasswordBackground.d3b504b4.jpg";